const getMarketoCookie = () => {
  const match = document.cookie.match(new RegExp('(^| )_mkto_trk=([^;]+)'));
  return match && match[2];
};

export default getMarketoCookie;
